module.exports = __webpack_public_path__ + "img/silo_img6.498a9de6.jpeg";